import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../environment';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {ICustomerResponseList} from '../model/customer.model';
import {ICreditTermsResponse} from '../model/credit-terms.model';

export type EntityArrayResponseType = HttpResponse<ICustomerResponseList>;
export type EntityResponseType = HttpResponse<ICreditTermsResponse>;

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  private apiWsCustomer = `${environment.wsApiBaseUrl}/api/customer`
  protected readonly http = inject(HttpClient);

  findByName(name: any): Observable<EntityArrayResponseType> {
    return this.http.get<ICustomerResponseList>(`${this.apiWsCustomer}`, {observe: 'response', params: {name}});
  }

  getCreditTermsByAddressNumber(addressNumber: any): Observable<EntityResponseType> {
    return this.http.get<ICreditTermsResponse>(`${this.apiWsCustomer}/credit-limit/${addressNumber}`, {observe: 'response'});
  }

  getCustomerDataByANs(ans: string | number[]): Observable<EntityArrayResponseType> {
    const ansParam = Array.isArray(ans) ? ans.join(',') : ans;
    return this.http.get<ICustomerResponseList>(`${this.apiWsCustomer}`, {observe: 'response', params: {ans: ansParam}});
  }

}
